'use client';

import { useLazyForgottenPasswordQuery } from '@/src/api/api';
import ModalTitle from '@components/ModalTitle';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';

export default function ForgottenForm() {
  const t = useTranslations('ForgottenPasswordForm');

  const afterForgotten = useSearchParams().get('forgotten');
  const [forgottenQuery, { data, isLoading }] = useLazyForgottenPasswordQuery();
  const [message, setMessage] = useState('');
  const forgotten = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');
    const formData = new FormData(e.currentTarget);
    const formValues = Object.fromEntries(formData);
    forgottenQuery(formValues).then((res) => {
      if (res.isSuccess) {
        setMessage(res.data.message);
      }
    });
  };
  return (
    <>
      <ModalTitle title={t('title')} />
      {afterForgotten && <p>{t('checkEmail')}</p>}
      <form method='post' onSubmit={forgotten}>
        <div className='-mx-3 flex flex-wrap'>
          <div className='w-full px-3'>
            <label
              htmlFor='email'
              className='mb-2 block text-sm font-bold uppercase'
            >
              {t('label.email')}
            </label>
            <input
              name='email'
              id='email'
              className='block w-full appearance-none rounded-sm p-2 text-dark'
              placeholder={t('placeholder.email')}
            />
          </div>
        </div>
        <div className='-mx-3 flex flex-wrap'>
          <div className='w-full px-3'>
            <button
              type='submit'
              className='mb-1 mt-4 w-full appearance-none rounded-sm border border-brand bg-brand p-2 font-bold uppercase text-black transition-all hover:bg-transparent hover:text-white'
            >
              {t('submit')}
            </button>
          </div>
        </div>
        {isLoading && <span className='text-white'>{t('loading')}</span>}
        {message}
      </form>
    </>
  );
}
